import React from 'react'
import style from './PrimeraParte.module.css'

const PrimeraParte = ({ t }) => {
  return (
      <div className={style.container}>
        <p className={style.titulo}>{t('Products.SyncFlow.FirstPart.title')}&nbsp;{t('Products.SyncFlow.FirstPart.title2')}</p>
        <div className={style.divContainer}>
          <div className={style.divIzq}>
            <p className={style.text}>{t('Products.SyncFlow.FirstPart.text')}</p>
            <p className={style.text}>{t('Products.SyncFlow.FirstPart.text2')}</p>
            <p className={style.title}>{t('Products.SyncFlow.FirstPart.title3')}</p>
            <div className={style.separador}></div>
            <ul className={style.ul}>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li2')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li3')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li4')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li5')}</li>
            </ul>
          </div>
          <div className={style.divDer}>
            <p className={style.title}>{t('Products.SyncFlow.FirstPart.title4')}</p>
            <div className={style.separador}></div>
            <ul className={style.ul}>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li6')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li7')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li8')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li9')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li10')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li11')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li12')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li13')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li14')}</li>
            </ul>
          </div>
        </div>
      </div>
    )
}

export default PrimeraParte